import { call, put, takeEvery } from "redux-saga/effects";
import profileManagerService from "services/ProfileManagerService";
import { uploadAvatarSuccess } from "store/actions";
import {
  getProfileFail,
  getProfileSuccess,
  updateProfileFail,
  updateProfileSuccess,
  uploadAvatarFail,
} from "./actions";
import { GET_PROFILE, UPDATE_PROFILE, UPLOAD_AVATAR } from "./actionTypes";

function* fetchGetProfile() {
  try {
    // Call api
    const response = yield call(profileManagerService.getProfile);
    if (response) {
      let avatarImg = null;
      if (response?.ext_value?.avatar_id) {
        // Check if have avatar
        try {
          const responseAvatar = yield call(
            profileManagerService.getAvatar,
            response.ext_value.avatar_id
          );
          if (responseAvatar) {
            avatarImg = URL.createObjectURL(responseAvatar);
          }
        } catch (errorAvatar) {}
      }
      yield put(
        getProfileSuccess(response, response?.ext_value?.avatar_id, avatarImg)
      );
    } else {
      yield put(getProfileFail("GetProfile error"));
    }
  } catch (error) {
    yield put(getProfileFail(error));
  }
}

function* fetchUploadAvatar({ data }) {
  try {
    const response = yield call(profileManagerService.uploadAvatar, data);
    if (response) {
      yield put(uploadAvatarSuccess(response.id));
    } else {
      yield put(uploadAvatarFail("Upload avatar error"));
    }
  } catch (error) {
    yield put(uploadAvatarFail(error));
  }
}

function* fetchUpdateProfile({ display_name, avatar_id }) {
  try {
    const response = yield call(
      profileManagerService.updateProfile,
      display_name,
      avatar_id
    );
    if (response) {
      let avatarImg = null;
      if (response?.ext_value?.avatar_id) {
        // Check if have avatar
        try {
          const responseAvatar = yield call(
            profileManagerService.getAvatar,
            response.ext_value.avatar_id
          );
          if (responseAvatar) {
            avatarImg = URL.createObjectURL(responseAvatar);
          }
        } catch (errorAvatar) {}
      }
      yield put(
        updateProfileSuccess(response, response.ext_value.avatar_id, avatarImg)
      );
    } else {
      yield put(updateProfileFail("Update profile error"));
    }
  } catch (error) {
    yield put(updateProfileFail(error));
  }
}

function* ProfileSaga() {
  yield takeEvery(GET_PROFILE, fetchGetProfile);
  yield takeEvery(UPLOAD_AVATAR, fetchUploadAvatar);
  yield takeEvery(UPDATE_PROFILE, fetchUpdateProfile);
}

export default ProfileSaga;
